import { INSIGHTS_HUB_URLS } from "@urls";

export default [
  {
    appTitle: true,
    header: "Insights Hub",
    icon: "fa-kit fa-hdp-app-insights-hub",
    baseRoute: INSIGHTS_HUB_URLS.baseUrl,
  },
  {
    header: "Hub",
    children: [
      {
        name: "All Dashboards",
        route: `${INSIGHTS_HUB_URLS.HUB}/all-dashboards`,
        permissions: ["accounts.insights_hub_access"],
      },
      {
        name: "Favorite Dashboards",
        route: `${INSIGHTS_HUB_URLS.HUB}/favorite-dashboards`,
        permissions: ["accounts.insights_hub_access"],
      },
      {
        name: "Recent Dashboards",
        route: `${INSIGHTS_HUB_URLS.HUB}/recent-dashboards`,
        permissions: ["accounts.insights_hub_access"],
      },
      {
        name: "Ad Hoc Analysis",
        route: `${INSIGHTS_HUB_URLS.HUB}/ad-hoc-analysis`,
        permissions: ["accounts.insights_hub_access"],
      },
    ],
  },
];
